/** @jsxImportSource @emotion/react */
import { Grid, Typography } from '@mui/material';
import { useContext } from 'react';
import { Il8nContext } from '../../Helper/i18n';
import FilterNoneSharpIcon from '@mui/icons-material/FilterNoneSharp';

function BrokeragePlan(props) {
    const localeText = useContext(Il8nContext)
    const { plan, handleBrokeragePlanSelection, selectedPlan, isSmallScreen, getDPChargeUI, paymentDone, toggleMarginDetailsPopup } = props
    const isCurrentPlanSelected = selectedPlan?.id == plan.id
    
    const numberDiffer = (val) =>{
        if(val >= 10000000) val = (val/10000000) + ' Cr';
        else if(val >= 100000) val = (val/100000) + ' Lac';
        else if(val >= 1000) val = (val/1000) + ' K';
        else val = (val/1000)
        return val;
    }
    

    const getPlanUI = ()=>{
        return (
        <Grid container item xs={12} md={4} lg={4} xl={2.25} css={{
                border: "1px solid #D9DEE2", borderRadius: "5px", cursor: "pointer", 
                opacity: (isCurrentPlanSelected ? 1 : 0.5),
                boxShadow: isCurrentPlanSelected ? "0px 3px 6px #00000026" : "none",
                marginBottom:"15px", padding: "0 !important"
            }}
            onClick={() => !paymentDone && handleBrokeragePlanSelection(plan)}
        >
            <Grid item xs={12} css={{ 
                backgroundColor: (plan.id == 6 || plan.id == 7) ? "#0B95A8" : plan.id == 8 ? "#2BA7E0" : plan.id == 9 ? "#8F49A8" : plan.id == 21 && "#FF9D00", 
                borderRadius: "5px", 
                padding: "8px",
                boxShadow: "0px 3px 6px #00000026" 
            }}>
                <Typography variant={"h6"} display={"inline"} css={{  color: "white" }}>
                    {plan.name}
                </Typography>
            </Grid>
            {((isSmallScreen && isCurrentPlanSelected) || !isSmallScreen) && 
                <>
                    <Grid item xs={12} css={{ padding: "10px" }}>
                        <Typography variant={"h5"} display={"inline"} css={{ textShadow: "0px 3px 2px #00000029", fontWeight: "bold", paddingLeft: "10px" }}>
                            {plan.isVariableMarginAmount ? `${numberDiffer(plan.mAmount)} - ${numberDiffer(plan.maxMarginAmount)}` : numberDiffer(plan.mAmount)}
                        </Typography>
                        <Typography variant={"body1"} display={"inline"} css={{ marginLeft: "10px", color: "#838383" }}>
                            {localeText?.planDetailsMargin}(₹)
                        </Typography>
                    </Grid>
                    <Grid container item xs={12}>
                        <Grid item xs={12} css={{ backgroundColor: "#F7F8FB", padding: "10px" }}>
                            <Typography display={"inline"} css={{ paddingLeft: "12px" }}>
                            {localeText?.planDetailsIntraday}
                            </Typography>
                            <Typography display={"inline"} css={{ float: "right", paddingRight: "10px" }}>
                                {plan.delvMPaisa+ "%"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} css={{ padding: "10px" }}>
                            <Typography display={"inline"} css={{ paddingLeft: "12px" }}>
                            {localeText?.planDetailsDelivery}
                            </Typography>
                            <Typography display={"inline"} css={{ float: "right", paddingRight: "10px" }}>
                                {plan.delvMxPerc+ "%"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} css={{ padding: "10px" }}>
                            <Typography variant="body2" color="#3C98B0" css={{float:"right", paddingRight:"10px"}} onClick={isCurrentPlanSelected ? toggleMarginDetailsPopup : null}>
                                {"Details"}
                                <FilterNoneSharpIcon fontSize='12px' css={{marginLeft:"5px"}} />
                            </Typography>
                        </Grid>
                    </Grid>
                </>
            }
        </Grid>)
    }

    return (isSmallScreen ? 
            <Grid container item xs={12} css={{border : isCurrentPlanSelected ? "1px solid lightgrey" : "none", borderRadius: "10px", padding: "10px"}}>
                {getPlanUI()}
                {isCurrentPlanSelected && getDPChargeUI()}
            </Grid>
        :
        getPlanUI()
    );
}

export default BrokeragePlan;
